// import icon from "../../../../assets/images/leftMenu/basePortal/icon_gaphic.png"
let icon = "icon-portal-image_and_text"
export default {
  name: "图文列表",
  id: "",
  thumbnail: icon,
  type: "cxGaphic",
  componentType:"emptyLayoutComponent",
  // typeId: "15ab8df95a85e111ed0b1e43ed6bcee52248",
  typeId: "",
  children: []
}
